import { CRM_QUERY_KEYS, buildReminderClientState } from '../hooks/useClients';

export const resolveLastContactDate = (client, { selectedClientId, selectedActivities, queryClient }) => {
  if (client.lastContactDate) return client.lastContactDate;

  if (client.id === selectedClientId && selectedActivities?.length) {
    return selectedActivities[0].createdAt || null;
  }

  const cachedActivities = queryClient.getQueryData(CRM_QUERY_KEYS.activities(client.id));
  if (cachedActivities?.length) {
    return cachedActivities[0].createdAt || null;
  }

  return null;
};

export const resolveCreatedBy = (client, queryClient) => {
  if (client.createdBy) return client.createdBy;

  const cachedDetails = queryClient.getQueryData(CRM_QUERY_KEYS.clientDetails(client.id));
  return cachedDetails?.createdBy || '';
};

export const resolveReminderState = (client, queryClient) => {
  const cachedReminder = queryClient.getQueryData(CRM_QUERY_KEYS.activeReminder(client.id));

  if (cachedReminder !== undefined) {
    return buildReminderClientState(client, cachedReminder);
  }

  if (client.hasActiveReminder) {
    return {
      id: client.id,
      companyName: client.companyName,
      hasActiveReminder: true,
      remindAt: client.remindAt || null,
      reminderId: client.reminderId || null,
    };
  }

  return buildReminderClientState(client, null);
};
